import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutManagerRoutingModule } from './layout-manager-routing.module';
import { LayoutManagerComponent } from './layout-manager.component';
import { ProfileModuleModule } from '../modules/profile-module/profile-module.module';
import { OmsModule } from '../modules/oms/oms.module';
import { RfqModule } from '../modules/rfq/rfq.module';
import { ElementsModule } from "../shared/elements/elements.module";
import { icons, LucideAngularModule } from 'lucide-angular';
import { MaterialModule } from '../shared/material/material.module';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';


@NgModule({
  declarations: [
    LayoutManagerComponent
  ],
  imports: [
    CommonModule,
    LayoutManagerRoutingModule,
    ProfileModuleModule,
    RfqModule,
    OmsModule,
    ElementsModule,
    MaterialModule,
    NgxIntlTelInputModule,
    LucideAngularModule.pick(icons),
]
})
export class LayoutManagerModule { }
